import { useAdmin } from "../../../../context/admin";
import { useGlobal } from "../../../../context/global";
import AdminService from "../../../../services/admin.service";
import Modal from "../../../common/Modal";
import { AiFillCloseCircle } from "react-icons/ai";
import { add } from "date-fns";

export default function ConfirmUnassignReservation() {
    const {setMessage} = useGlobal()
    const {confirmUnassignReservationId, setCurrentDay, setConfirmUnassignReservationId} = useAdmin()

    async function onSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault()
        try {
            await AdminService.unassignTrip(confirmUnassignReservationId!)
            await setCurrentDay((prevDay: Date) => add(prevDay, {days: 1}))
            await setCurrentDay((prevDay: Date) => add(prevDay, {days: -1}))
            setMessage({
                type: 'success',
                content: 'Reservation successfully unassigned from trip'
            })
            setTimeout(() => setMessage(undefined), 2500)
            setConfirmUnassignReservationId(undefined)

        } catch (error) {
            
        }
    }
    return (
        <Modal onSubmit={onSubmit}>
            <h1>Are you sure you want to unassign this reservation from its trip?</h1>
            <p>This action cannot be undone.</p>
            {/* Buttons for confirming or cancelling the deletion would go here */}
            <div className="actions" style={{display: 'flex', gap: '10px', marginTop: '20px'}}>
                <button style={{backgroundColor: 'red', color: 'white', border: 'none'}}
                >Unassign</button>
                <button type="button" style={{backgroundColor: 'gray', color: 'white', border: 'none'}}
                onClick={() => setConfirmUnassignReservationId(undefined)}
                >Cancel</button>
            </div>
            <div className="close" onClick={() => setConfirmUnassignReservationId(undefined)}>
                <AiFillCloseCircle />
            </div>
        </Modal>
    )
}